import {ClaimResponse, RewardListType, RewardResponse, RewardsResponse} from '../interfaces/sdk';
import swap from "../utils/swap";
import {pageInfo, settings} from "../global";
import {apiClient} from "../httpClient";

export const claimReward = async (rewardId = '', requestId = '', lang = '', userConsent: string | undefined) => {
  const body = {
    user_consent: userConsent,
  }
  return await apiClient.post<ClaimResponse>(
    `/sdk/claim/rewards/${rewardId}/${requestId}`,
    body,
    {
      headers: { lang},
      params: { page_info_url: pageInfo.url }
    }
  )
}

export const resendRewardEmail = async (claimId: string, requestId: string) => {
  const body = { claimId, requestId}
  return apiClient.post<any>(`/sdk/rewards/resend-email`, body, {params: { page_info_url: pageInfo.url }})
}

type FetchRewardsParams = {
  list_type: RewardListType;
  limit?: number,
  reward_id?: string,
}

export const fetchRewards = async (params: FetchRewardsParams) => {
  let reqPath = '/sdk/rewards';
  if (params.list_type) {
    reqPath = `${reqPath}/${params.list_type}`;
  }
  const urlParams = {
    limit: `${params.limit}`,
    reward_id: params.reward_id,
    ...{
      page_info_url: pageInfo.url,
      page_info_tags: pageInfo.tags,
    },
    init_source: settings.initSource
  }

  const data = await apiClient.get<RewardsResponse>(`${reqPath}`, {params: urlParams})

  // Put the reward at first position in the list
  if (params.reward_id && params.list_type !== 'claimed') {
    const rewardIndex = data.data.payload.findIndex(reward => reward.id === params.reward_id)
    if (rewardIndex !== -1) {
      swap(data.data.payload, 0, rewardIndex)
    }
  }

  return data
}

type FetchMissedBrandsParams = {
  limit?: number,
}

// "Deals you've missed" — brands the user was eligible for but whose offers have since expired.
// Same response shape as the reward list; we only consume the brand fields on each payload item.
export const fetchMissedBrands = async (params: FetchMissedBrandsParams = {}) => {
  const urlParams = {
    limit: params.limit ? `${params.limit}` : undefined,
    page_info_url: pageInfo.url,
    page_info_tags: pageInfo.tags,
    init_source: settings.initSource,
  }
  return apiClient.get<RewardsResponse>(`/sdk/rewards/missed-brands`, {params: urlParams})
}

export const fetchOneReward = async (rewardId: string, requestId: string) => {
  return apiClient.get<RewardResponse>(`/sdk/rewards/${rewardId}/${requestId}`, {params: { page_info_url: pageInfo.url }})
}

export const fetchClaimedReward = async (claimId:string) => {
  return apiClient.get<RewardResponse>(`/sdk/rewards/claimed/${claimId}`, {params: { page_info_url: pageInfo.url }})
}
